module.exports = __webpack_public_path__ + "static/media/stefanKroll.f7d02c08.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/stefanKroll.jpg
// module id = 1698
// module chunks = 1